import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class ChangeBankCompanyCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(ids:Array<String>, companyId:Number|String): Promise<any> {
    let args = { 
      ids: ids,
      company_id: companyId,
    }
    this.frontend.dialogChangeCompanies = false;
    await this.dispatcher.dispatch('change.bank_account.company', args)
    this.frontend.loadingActions = false;
    this.frontend.selectedItems = []
    this.frontend.selectedCompany = null
  }
}